import { FC } from "react";


const PicaxeLogo: FC = () => {
	return (
		<svg
			width="147"
			height="34"
			viewBox="0 0 147 34"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M134.86 10.4397H146.461V12.8628H137.623V15.5822H145.45V17.8571H137.623V21.6487H146.644V24.063H134.86V10.4397Z"
				fill="white"
			/>
			<path
				d="M123.878 17.1424L118.639 10.4397H122.021L125.638 15.129L129.273 10.4397H132.602L127.268 17.1163L132.785 24.063H129.395L125.516 19.1646L121.55 24.063H118.212L123.878 17.1424Z"
				fill="white"
			/>
			<path
				d="M108.372 10.4397H111.3L117.89 24.063H114.987L113.898 21.7707H105.94L104.885 24.063H101.974L108.372 10.4397ZM112.808 19.4958L109.862 13.3073L106.994 19.4958H112.808Z"
				fill="white"
			/>
			<path
				d="M88.8736 10.4397H91.6366V17.4911L98.8274 10.4397H102.366L95.6547 16.942L102.366 24.063H98.6879L93.6674 18.8682L91.6366 20.8293V24.063H88.8736V10.4397Z"
				fill="white"
			/>
			<path
				d="M71.6592 17.1686C71.6592 16.1982 71.8422 15.2946 72.2083 14.4578C72.5744 13.6153 73.1032 12.886 73.7947 12.2701C74.492 11.6484 75.3403 11.1602 76.3398 10.8058C77.345 10.4513 78.481 10.2741 79.7478 10.2741C80.8576 10.2741 81.8745 10.3874 82.7984 10.614C83.7281 10.8348 84.591 11.1748 85.3871 11.6338L84.1146 13.7257C83.8763 13.5688 83.6003 13.4293 83.2865 13.3073C82.9785 13.1853 82.6473 13.0836 82.2929 13.0023C81.9442 12.9151 81.5811 12.8483 81.2034 12.8018C80.8315 12.7553 80.4625 12.7321 80.0964 12.7321C79.2132 12.7321 78.4258 12.8425 77.7343 13.0633C77.0429 13.2783 76.4589 13.5833 75.9824 13.9785C75.5117 14.3678 75.1515 14.8355 74.9016 15.3818C74.6576 15.9222 74.5355 16.5178 74.5355 17.1686C74.5355 17.8426 74.6634 18.4615 74.919 19.0251C75.1747 19.5887 75.5437 20.0768 76.026 20.4894C76.5141 20.8962 77.1068 21.2157 77.8041 21.4482C78.5072 21.6748 79.3003 21.7881 80.1836 21.7881C80.5845 21.7881 80.9826 21.7591 81.3777 21.7009C81.7728 21.6428 82.1534 21.5644 82.5195 21.4656C82.8914 21.361 83.2487 21.239 83.5916 21.0995C83.9344 20.9543 84.254 20.7974 84.5504 20.6289L85.8229 22.7207C85.0791 23.1972 84.2191 23.572 83.2429 23.8451C82.2667 24.1124 81.2295 24.2461 80.1313 24.2461C78.7309 24.2461 77.5019 24.0659 76.4444 23.7057C75.3868 23.3396 74.5036 22.8399 73.7947 22.2065C73.0857 21.5673 72.5512 20.8177 72.1909 19.9577C71.8364 19.0919 71.6592 18.1622 71.6592 17.1686Z"
				fill="white"
			/>
			<path
				d="M66.1768 10.4397H68.9572V24.063H66.1768V10.4397Z"
				fill="white"
			/>
			<path
				d="M50.1914 10.4397H57.3735C58.4194 10.4397 59.3259 10.553 60.0929 10.7797C60.8599 11.0063 61.4962 11.3346 62.0017 11.7646C62.5073 12.1888 62.8821 12.7088 63.1261 13.3248C63.376 13.9407 63.5009 14.6351 63.5009 15.4079C63.5009 16.1343 63.3789 16.8054 63.1348 17.4213C62.8908 18.0373 62.516 18.5719 62.0104 19.0251C61.5107 19.4725 60.8773 19.8241 60.1103 20.0798C59.3433 20.3296 58.4368 20.4546 57.3909 20.4546L52.9544 20.4458V24.063H50.1914V10.4397ZM57.4432 18.0576C57.9662 18.0576 58.4223 17.9966 58.8116 17.8746C59.2068 17.7467 59.5351 17.5695 59.7965 17.3429C60.0638 17.1105 60.2614 16.8316 60.3892 16.5061C60.5229 16.1749 60.5897 15.8089 60.5897 15.4079C60.5897 14.6002 60.3253 13.9727 59.7965 13.5252C59.2736 13.072 58.4891 12.8454 57.4432 12.8454H52.9544V18.0576H57.4432Z"
				fill="white"
			/>
			<path
				d="M30.2394 12.9517C29.9234 11.4597 28.3963 10.465 27.6723 10.1541L30.1077 7.82278C29.3705 7.2899 29.8006 6.71262 30.1077 6.49058C28.37 3.66633 25.2587 2.29416 23.9203 1.96112C22.7618 1.5881 23.1305 0.961968 23.4596 0.695529C24.6181 0.269226 26.9702 0.606715 28.0014 0.828748C29.6338 1.0419 32.1044 2.82704 33.1356 3.69297C33.4516 3.21338 33.9255 3.27111 34.123 3.35992L37.2167 6.69041C37.5853 7.27658 37.1509 7.86719 36.8876 8.08922C38.9939 11.1266 39.5644 13.1738 39.5863 13.8177C39.7443 15.363 39.5205 17.126 39.3888 17.8143C38.8096 18.6136 38.226 18.0585 38.0066 17.681C37.4273 13.9509 35.0884 11.5085 33.9913 10.7536C33.4647 11.2332 32.9382 10.9534 32.7407 10.7536L30.2394 12.9517Z"
				fill="white"
			/>
			<path
				d="M9.90923 12.9517C10.2252 11.4597 11.7523 10.465 12.4763 10.1541L10.0409 7.82278C10.7781 7.2899 10.3481 6.71262 10.0409 6.49058C11.7786 3.66633 14.8899 2.29416 16.2283 1.96112C17.3868 1.5881 17.0182 0.961968 16.689 0.695529C15.5306 0.269226 13.1785 0.606715 12.1472 0.828748C10.5148 1.0419 8.04423 2.82704 7.013 3.69297C6.69705 3.21338 6.22312 3.27111 6.02565 3.35992L2.93194 6.69041C2.56333 7.27658 2.99777 7.86719 3.26106 8.08922C1.15471 11.1266 0.584242 13.1738 0.5623 13.8177C0.404324 15.363 0.628124 17.126 0.759771 17.8143C1.33902 18.6136 1.92265 18.0585 2.14206 17.681C2.72131 13.9509 5.06024 11.5085 6.15729 10.7536C6.68388 11.2332 7.21047 10.9534 7.40794 10.7536L9.90923 12.9517Z"
				fill="white"
			/>
			<path
				d="M10.6791 26.1717L7.16691 29.64C5.41082 32.0751 8.36106 34.1413 9.5552 33.3296L13.3484 29.3448C11.9435 28.7545 10.9835 26.9834 10.6791 26.1717Z"
				fill="white"
			/>
			<path
				d="M29.4695 26.1717L32.9817 29.64C34.7378 32.0751 31.7875 34.1413 30.5934 33.3296L26.8002 29.3448C28.2051 28.7545 29.1651 26.9834 29.4695 26.1717Z"
				fill="white"
			/>
			<path
				d="M17.678 21.9247L20.2373 18.2229L22.6377 22.0314L24.8028 20.5662L27.4117 23.3662L25.2012 25.3417L22.8049 26.7832H18.7926L15.1703 25.662L12.7369 23.3662L15.5088 20.41L17.678 21.9247Z"
				fill="url(#PickaxeLogoGradient)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.38 26.2572C23.973 26.2572 26.8857 23.3445 26.8857 19.7516C26.8857 16.1586 23.973 13.246 20.38 13.246C16.7871 13.246 13.8744 16.1586 13.8744 19.7516C13.8744 23.3445 16.7871 26.2572 20.38 26.2572ZM20.38 28.6176C25.2766 28.6176 29.246 24.6481 29.246 19.7516C29.246 14.855 25.2766 10.8856 20.38 10.8856C15.4835 10.8856 11.514 14.855 11.514 19.7516C11.514 24.6481 15.4835 28.6176 20.38 28.6176Z"
				fill="white"
			/>

			<defs>
				<linearGradient
					id="PickaxeLogoGradient"
					x1="13"
					y1="21.5"
					x2="26.9471"
					y2="20.3555"
					gradientUnits="userSpaceOnUse"
				>
					<stop
						offset="0.26"
						stopColor="#FF9823"
					/>
					<stop
						offset="1"
						stopColor="#FF5E2C"
					/>
				</linearGradient>
			</defs>
		</svg>
	)
}

export default PicaxeLogo;